export enum AccountOrderDetailPageState {
  Paying = 'paying',
  ChangingPaymentMethod = 'change-payment-method',
  ChangingShippingAddress = 'change-shipping-method'
}
